import { namespace as LocationsNamespace } from '@store/modules/locations.types';

import PressSheetsApiService from './_services/pressSheets.api.service';

import { MutationTypes, ActionTypes } from './store.types';

export { namespace } from './store.types';

export default {
  namespaced: true,
  state: {
    pressSheet: {},
    pressSheets: [],
    pressSheetHistory: [],
  },
  mutations: {
    [MutationTypes.SET_PRESS_SHEET](state, payload) {
      state.pressSheet = payload;
    },
    [MutationTypes.SET_PRESS_SHEETS](state, payload) {
      state.pressSheets = payload;
    },
    [MutationTypes.SET_PRESS_SHEET_HISTORY](state, payload) {
      state.pressSheetHistory = payload;
    },
  },
  actions: {
    async [ActionTypes.GET_PRESS_SHEET](
      { commit, rootState: { [LocationsNamespace]: l } },
      { suffix = l.suffix, id },
    ) {
      commit(
        MutationTypes.SET_PRESS_SHEET,
        await PressSheetsApiService.getPressSheet({ suffix, id }),
      );
    },

    async [ActionTypes.GET_PRESS_SHEETS](
      { commit, rootState: { [LocationsNamespace]: l } },
      { suffix = l.suffix, ...rest },
    ) {
      commit(
        MutationTypes.SET_PRESS_SHEETS,
        await PressSheetsApiService.getPressSheets({ suffix, ...rest }),
      );
    },

    async [ActionTypes.GET_PRESS_SHEET_HISTORY](
      { commit, rootState: { [LocationsNamespace]: l } },
      { suffix = l.suffix, id },
    ) {
      commit(
        MutationTypes.SET_PRESS_SHEET_HISTORY,
        await PressSheetsApiService.getPressSheetHistory({ suffix, id }),
      );
    },
  },
};
